import React from 'react'

type MenuIconProps = {
  size?: number
  color?: string
}

export default function MenuIcon({
  size = 32,
  color = 'black',
}: MenuIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 32 32'
      xmlns='http://www.w3.org/2000/svg'
      // Bu joyda color beramiz
      style={{ color }}
    >
      <g clipPath='url(#clip0_4661_173363)'>
        <path
          d='M25.5312 5.93778H23.9688V2.18691C23.9688 1.48709 23.6302 0.824469 23.0631 0.414406C22.4961 0.00434357 21.7607 -0.109719 21.0961 0.109531L5.7835 5.15991C4.88494 5.45634 4.28125 6.29122 4.28125 7.23734V24.7083V29.8125C4.28125 31.0187 5.26256 32 6.46875 32H25.5312C26.7374 32 27.7188 31.0187 27.7188 29.8125V8.12528C27.7188 6.91916 26.7374 5.93778 25.5312 5.93778ZM25.8438 29.8125C25.8438 29.9848 25.7036 30.125 25.5312 30.125H6.46875C6.29644 30.125 6.15625 29.9848 6.15625 29.8125V23.7709V8.12528C6.15625 7.95297 6.29644 7.81278 6.46875 7.81278H25.5312C25.7036 7.81278 25.8438 7.95297 25.8438 8.12528V29.8125ZM21.6834 1.89016C21.8154 1.84666 21.9161 1.89878 21.9644 1.93372C22.0128 1.96866 22.0938 2.04797 22.0938 2.18691V5.93784H9.41113L21.6834 1.89016Z'
          fill='currentColor'
        />
        <path
          d='M9.75 18.6552H10.8864H22.25C22.7677 18.6552 23.1875 18.2355 23.1875 17.7177C23.1875 17.2 22.7677 16.7802 22.25 16.7802H21.9784C21.5743 14.1928 19.5249 12.1434 16.9375 11.7393V11.2695C16.9375 10.7518 16.5177 10.332 16 10.332C15.4823 10.332 15.0625 10.7518 15.0625 11.2695V11.7393C12.4751 12.1434 10.4257 14.1928 10.0216 16.7802H9.75C9.23225 16.7802 8.8125 17.2 8.8125 17.7177C8.8125 18.2355 9.23225 18.6552 9.75 18.6552ZM16 13.5416C17.9805 13.5416 19.6434 14.9275 20.0701 16.7802H11.9299C12.3566 14.9275 14.0196 13.5416 16 13.5416Z'
          fill='currentColor'
        />
        <path
          d='M10.1133 21.1875C9.59553 21.1875 9.17578 21.6072 9.17578 22.125C9.17578 22.6428 9.59553 23.0625 10.1133 23.0625H14.6133C15.131 23.0625 15.5508 22.6428 15.5508 22.125C15.5508 21.6072 15.131 21.1875 14.6133 21.1875H10.1133Z'
          fill='currentColor'
        />
        <path
          d='M22.0156 24.9375H9.98438C9.46662 24.9375 9.04688 25.3572 9.04688 25.875C9.04688 26.3928 9.46662 26.8125 9.98438 26.8125H22.0156C22.5334 26.8125 22.9531 26.3928 22.9531 25.875C22.9531 25.3572 22.5334 24.9375 22.0156 24.9375Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_4661_173363'>
          <rect width='32' height='32' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
